import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CarIcon = ({ title = 'Car', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    <g transform="translate(9 14)" stroke="currentColor" fill="none" fillRule="evenodd">
      <path
        d="M0 20.952c0-1.107.904-2.005 2.003-2.005H43.26c1.106 0 2.003.898 2.003 2.005v11.68H0v-11.68Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.69 9.168C6.026 4.105 11.362 0 16.592 0H28.67c5.236 0 10.565 4.1 11.904 9.168l2.584 9.78H2.105l2.584-9.78Z" />
      <circle cx="7.895" cy="25.789" r="2.632" />
      <circle cx="37.368" cy="25.789" r="2.632" />
      <path d="M15.263 26.842H30" strokeLinecap="round" />
      <path d="M0 32.632h6.316v4.371A2.998 2.998 0 0 1 3.306 40H3.01A3.01 3.01 0 0 1 0 37.003v-4.371ZM38.947 32.632h6.316v4.371A2.998 2.998 0 0 1 42.253 40h-.296a3.01 3.01 0 0 1-3.01-2.997v-4.371Z" />
    </g>
  </CreateIconComponent>
);

export default CarIcon;
